import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import AccountCreationModal from 'modules/expenses/components/common/AccountCreationModal'
import type { CtaDescription } from 'modules/expenses/components/common/CardsHero'
import CardsHero, { CardsImage } from 'modules/expenses/components/common/CardsHero'

import FAQSection from './FAQSection'
import FeaturesSection from './FeaturesSection'
import StepsSection from './StepsSection'

interface CardsLandingPageContentProps {
  ctaDescription: CtaDescription
  onContactSupportClick: () => void
  onFAQCardClick?: (question: string) => void
}

const CardsLandingPageContent: React.FC<CardsLandingPageContentProps> = ({
  ctaDescription,
  onContactSupportClick,
  onFAQCardClick,
}) => {
  const [isAccountCreationModalOpen, setIsAccountCreationModalOpen] = React.useState(false)

  const onGetCards = () => {
    setIsAccountCreationModalOpen(true)
  }

  return (
    <Box flexDirection="column" gap="s32" gapDivider>
      <CardsHero
        primaryButtonText={i18n.t('expenses_v2.cards.blocks.require_onboarding.get_my_cards_now')}
        ctaDescription={ctaDescription}
        cardsImage={CardsImage.MULTIPLE}
        isDismissable={false}
        onPrimaryButtonClick={onGetCards}
      />
      <StepsSection onGetCardsClick={onGetCards} />
      <FeaturesSection onGetCardsClick={onGetCards} />
      <FAQSection onContactSupportClick={onContactSupportClick} onFAQCardClick={onFAQCardClick} />
      {isAccountCreationModalOpen && (
        <AccountCreationModal
          source="expenses"
          trackingEvent={trackingEvents.expenses.goToCreateCardsAccount}
          onClose={() => {
            setIsAccountCreationModalOpen(false)
          }}
        />
      )}
    </Box>
  )
}

export default CardsLandingPageContent
